// Third-party imports
import $ from 'jquery';
import '@accessible360/accessible-slick';

// Module name
export const MODULE_NAME = 'slider';

export let global_vars = {};

export function initialize() {
    initStandard();
    initPadded();
    initAlternate();
    initIconSlider();
    mobileOnlySlider();
    tabletOnlySlider();
    documentPreviewSlider();
    gmSlider();
    collectionSliders();
    productSlider();
    productSliderInit();
    productSliderThumbs();
}

export function refreshDocumentPreviewSlider() {
    $('.documentPreviewSlider').slick('unslick');
    documentPreviewSlider();
}

// Get Current Language for Slide Label
let currentLang = document.body.dataset.lang;
let slideLabel;

switch (currentLang) {
    case currentLang === 'fr':
        slideLabel = 'Diapo';
        break;
    case currentLang === 'zh':
        slideLabel = '投影片';
        break;
    default:
        slideLabel = 'Slide';
}

// Shop by Category Slider
function collectionSliders() {
    $('.collection-slider').each(function() {
        let slickElement = $(this);
        let id = slickElement.attr('id');
        let status = $('.' + id + '-collection-slideshow-paging-info');

        $('#' + id).on('init reInit afterChange', function(
            _event,
            slick,
            currentSlide
        ) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            let i = (currentSlide ? currentSlide : 0) + 1;
            status.text(i + '/' + slick.slideCount);
        });

        $('#' + id).slick({
            prevArrow: $('.' + id + '-collection-slideshow-prev'),
            nextArrow: $('.' + id + '-collection-slideshow-next'),
            infinite: false,
            centerMode: true,
            centerPadding: '32px',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                    },
                },
            ],
        });
    });
}

function productSlider() {
    let slideCount = 0;
    $('#productSlider').on('init reInit afterChange', function(
        _event,
        slick,
        currentSlide
    ) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        slideCount = slick.slideCount;
        let i = (currentSlide ? currentSlide : 0) + 1;
        $('.product-slider-slideshow-paging-info').text(
            i + '/' + slick.slideCount
        );
    });

    $('#productSlider').slick({
        prevArrow: $('.product-slider-slideshow-prev'),
        nextArrow: $('.product-slider-slideshow-next'),
        infinite: slideCount > 1 ? true : false,
        centerMode: slideCount > 1 ? true : false,
        centerPadding: slideCount > 1 ? '32px' : '0',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    asNavFor: '#productSliderThumbs',
                    centerMode: false,
                    slidesToShow: 1,
                    prevArrow: false,
                    nextArrow: false,
                },
            },
        ],
    });
}

function productSliderThumbs() {
    $('#productSliderThumbs').on('init reInit afterChange', function(
        _event,
        slick
    ) {
        if (slick.slideCount > 1) {
            $('.carousel-controls--desktop .carousel-controls-btn').attr(
                'disabled',
                false
            );
        }
        if (slick.slideCount < 7) {
            $('.product-slider-thumbs .slick-track').addClass('no-transform');
        } else {
            $('.product-slider-thumbs .slick-track').removeClass(
                'no-transform'
            );
        }
    });

    $('#productSliderThumbs').slick({
        slidesToShow: 7,
        prevArrow: $('.product-slider-slideshow-prev'),
        nextArrow: $('.product-slider-slideshow-next'),
        asNavFor: '#productSlider',
    });
}

function productSliderInit() {
    $('.product-slider-thumbs').on('click', '.slick-slide', function() {
        const goToSingleSlide = $(this).data('slick-index');
        $('.product-slider').slick('slickGoTo', goToSingleSlide);
    });

    $('.product-slider-thumbs-slideshow-prev').on('click', function() {
        $('.product-slider').slick('slickPrev');
    });

    $('.product-slider-thumbs-slideshow-next').on('click', function() {
        $('.product-slider').slick('slickNext');
    });
}

export function gmSlider() {
    let status = $('.slideshow-paging-info');
    let slickElement = $('.gm-slideshow');

    slickElement.on('init reInit afterChange', function(
        event,
        slick,
        currentSlide
    ) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        let i = (currentSlide ? currentSlide : 0) + 1;
        status.text(slideLabel + ' ' + i + '/' + slick.slideCount);
    });

    slickElement.slick({
        prevArrow: $('.slideshow-prev'),
        nextArrow: $('.slideshow-next'),
        infinite: false,
    });
}
function documentPreviewSlider() {
    let sliderConfig = {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '0px',
        centerMode: false,
        infinite: false,
        responsive: [
            {
                // This is necessary in order to avoid interface glitches
                breakpoint: 1024,
                settings: {
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    $('.documentPreviewSlider')
        .not('.slick-initialized')
        .slick(sliderConfig);
}

function initStandard() {
    $('.standardSlider:not(.standardSlider--padded)').slick({
        dots: true,
    });
}

function initPadded() {
    $('.standardSlider--padded').slick({
        dots: true,
        centerMode: true,
        centerPadding: '400px',
        responsive: [
            {
                breakpoint: 2600,
                settings: {
                    centerPadding: '200px',
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    centerPadding: '80px',
                },
            },
            {
                breakpoint: 900,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                },
            },
        ],
    });
}

function initIconSlider() {
    $('.iconSlider').slick({
        centerMode: true,
        dots: true,
        centerPadding: '60px',
        customPaging: (slider, i) => {
            let icon = slider.$slides[i].querySelector('.iconSlider-slide')
                .dataset.pagingIcon;
            return '<svg><use xlink:href="' + icon + '"></use></svg>';
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    dots: false,
                },
            },
        ],
    });
}

function initAlternate() {
    $('.alternateSlider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
}

function mobileOnlySlider() {
    let windowWidth = $(window).outerWidth();
    if (windowWidth < 768) {
        $('.js-mobileOnlySlider-hook').addClass('slider--mobileOnly');
    } else {
        $('.js-mobileOnlySlider-hook').removeClass('slider--mobileOnly');
    }

    $('.slider--mobileOnly').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20px',
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick',
            },
        ],
    });
}

function tabletOnlySlider() {
    let mediaQuery = $(window)[0].matchMedia('(max-width: 1023px)');
    // Run on page init
    if (mediaQuery.matches) {
        applyTabletOnlySlider();
    }

    mediaQuery.addListener(() => {
        if (mediaQuery.matches) {
            applyTabletOnlySlider();
        } else {
            removeTabletOnlySlider();
        }
    });
}

function applyTabletOnlySlider() {
    $('.js-tabletOnlySlider-hook').addClass('slider--tabletOnly');
    $('.slider--tabletOnly')
        .not('.slick-initialized')
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '20%',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '5%',
                    },
                },
            ],
        });
}

function removeTabletOnlySlider() {
    $('.slider--tabletOnly').slick('unslick');
    $('.js-tabletOnlySlider-hook').removeClass('slider--tabletOnly');
}
